<ngx-loading-bar [includeSpinner]="false" height="5px" [color]="loadingBarColor()">
</ngx-loading-bar>

<!-- Custom overlay -->
<div class="loading-overlay" *ngIf="isLoading$ | async"></div>

@if ((config$ | async) && (lang$ | async)) {
  <div class="wrapper" [class]="wrapperClass$ | async" (window:resize)="onResize($event)">
    <router-outlet></router-outlet>
  </div>
}

@if ((fullscreenLoaderState$ | async)?.show) {
  <sliqpay-fullscreen-loader></sliqpay-fullscreen-loader>
}
